import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebService } from '../../services/web/web.service';
import { ConversationDetail, ConversationListResponse } from '../models/rag.models';

/**
 * AssistantConversationService — historial de conversaciones del Asistente Virtual.
 *
 * Cliente delgado sobre WebService (mismo patrón que el resto de servicios de
 * dominio): construye URLs sobre `webService.HOST`, que RagAuthInterceptor ya
 * reconoce (empieza con `${environment.backendUrl}/rag`) para añadir
 * Authorization + X-Partner-ID. Consume rutas ya proxeadas desde Fase 2 —
 * no agrega endpoints nuevos.
 */
@Injectable({ providedIn: 'root' })
export class AssistantConversationService {

  private readonly baseUrl: string;

  constructor(private webService: WebService) {
    this.baseUrl = `${this.webService.HOST}/rag/api/conversations`;
  }

  list(page: number, size: number): Observable<ConversationListResponse> {
    const params = new HttpParams()
      .set('page', String(page))
      .set('size', String(size));
    return this.webService.get(this.baseUrl, params);
  }

  get(conversationId: string): Observable<ConversationDetail> {
    return this.webService.get(`${this.baseUrl}/${conversationId}`);
  }

  delete(conversationId: string): Observable<any> {
    return this.webService.delete({}, `${this.baseUrl}/${conversationId}`);
  }
}
